import React from "react"
import styled from "@emotion/styled";
import ReactPlayer from "react-player"

const Container = styled.div`

`

const TumannyyVideo = () => {
    return (
        <Container>
            <ReactPlayer url="https://www.youtube.com/watch?v=ETCg-KsUFJI" />
        </Container>
    )
}

export default TumannyyVideo;